export default __webpack_public_path__ + "static/logo-ua-81321f56899abec179889ca996489a55.svg";